import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { Lot, LotCollectionResponse, LotGetCollectionByProjectId, LotGetCollectionByStageId } from '../../api/dtos';

const getData = (response?: SWRResponse<LotCollectionResponse, LotCollectionResponse>) => {
    return response?.data?.data;
}
const getError = (response?: SWRResponse<LotCollectionResponse, LotCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});
const getAdditionalState = (response?: SWRResponse<LotCollectionResponse, LotCollectionResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, Lot>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}): undefined
});

const useLotsByProjectIdStageId = (projectId?: number, stageId?: number, configuration?: SWRConfiguration<LotCollectionResponse, LotCollectionResponse>) => {
    
    const request = useMemo(() => {
        if(stageId != undefined && !Number.isNaN(stageId)) {
            return () => {
                return new LotGetCollectionByStageId({
                    stageId: stageId
                }) 
            }
        }
        else if(projectId != undefined) {
            return () => {  
                return new LotGetCollectionByProjectId({
                    projectId: projectId
                }) 
            }
        }
        else {
            return undefined;
        }
        
    }, [projectId, stageId])

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useLotsByProjectIdStageId;